import { SingleValueCardType } from "constants/index";
import {
  PDFReportValueItem,
  PDFReportValueType,
  ReportValueCardProps,
} from "helpers/types";

const CARD_TYPE_TO_PDF_TYPE: Record<SingleValueCardType, PDFReportValueType> = {
  [SingleValueCardType.CURRENCY]: PDFReportValueType.CURRENCY,
  [SingleValueCardType.PERCENTAGE]: PDFReportValueType.PERCENTAGE,
  [SingleValueCardType.NUMBER]: PDFReportValueType.NUMBER,
};

const cardTypeToPdfType = (
  type: SingleValueCardType,
  label: string,
): PDFReportValueType =>
  label.toLowerCase().includes("share")
    ? PDFReportValueType.SHARES
    : CARD_TYPE_TO_PDF_TYPE[type];

export const toPdfValues = (
  items: ReportValueCardProps[],
): PDFReportValueItem[] =>
  items.map((item) => ({
    label: item.label,
    value: Number(item.value),
    type: cardTypeToPdfType(item.type, item.label),
  }));
